<template>
    <div class="map-progress-semi-circle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248 124">
            <path :style="{fill: color}"
                  d="M124,0A124,124,0,0,1,247.36,111.32L248,124H195.73a71.73,71.73,0,0,0-143.47,0H0A124,124,0,0,1,124,0"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: "MapProgressSemiCircle",
    props: {
        color: {
            type: String,
            default: '#333333',
        }
    }
}
</script>

<style scoped>

</style>
